const COMPANY_INFO = {
  name: 'Caribbean Gas Company SRL',
  rnc: '131827586',
  address: 'Calle Principal Remanzo #23 Los Alcarrizos, Santo Domingo',
  phone: '829-213-4755',
  email: 'ventas@caribbeangas.com',
  website: 'www.caribbeangas.com',
};

export default COMPANY_INFO;
